import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { helveticaBold } from '../../theme-constants/typograhy-overrides';



export const modalStyles = makeStyles((theme) => ({
    modalWrapper: {
        display:'flex',
        padding: '4rem 1.5rem',
        justifyContent: 'center',
        alignItems: 'flex-start',
        '& .modal': {
            '&-header': {
                '&-logo': {
                    display: 'block',
                    width: '11.5rem',
                },
            },

            '&-container': {
                height: '100%', 
                
            },
            '&-inner': {
                height: '100%',
                width: '100%',
                maxWidth: '50rem',
                overflow: 'hidden',
                margin : '0 auto',

                '&-large': {
                    maxWidth: '84rem',
                },

                '& > button': {
                    color: tcsmColors.white,
                    alignSelf: 'flex-end',
                    marginBottom: theme.spacing(.5),

                },

            },
            '&-close': {
                display: 'flex',
                justifyContent: 'flex-end',
                '&-button': {
                    color: tcsmColors.white,
                    alignSelf: 'flex-end',
                    marginBottom: theme.spacing(.5),
                    background: 'transparent',
                    padding: '0',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',

                    fontFamily: helveticaBold,
                    '& svg': {
                        height: '.875rem',
                        width: '.875rem',
                        marginLeft: theme.spacing(.5),
                        fill: tcsmColors.white,
                    },
                },
            },
            '&-content': {
                height: '100%',
                '&-inner': {
                    overflow: 'auto',
                    borderRadius: '3px',
                    padding: theme.spacing(1.5),
                    background: tcsmColors.white,
                    boxShadow: '0px 12px 24px rgba(48, 48, 48, 0.3)',
                    maxHeight:'100%',
                },
                '&-title': {
                    marginBottom: theme.spacing(.75),
                },
                '&-subtitle': {
                    marginBottom: theme.spacing(.5),
                },
            },
            '&-file-link': {
                marginTop: theme.spacing(1),
            },
        },

    },



}));



